<template>
  <div class="time-sheet-entry-border" style="height: 100%;">
    <v-row>
      <v-col cols="12" class="text-center">
        <b>{{ day.dayOfTheWeek }}</b>
        <br>
        <b>{{ day.date | formatDate }}</b>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="pt-0"
        v-for="row in day.rows"
        :key="row.timeTypeId"
      >
        <FormattedNumberField
          :label="showLabels ? row.label : undefined"
          :readonly="!row.editable"
          :value="row.entry.hours"
          :required="false"
          :dense="true"
          :validateOnBlur="true"
          :hideDetails="true"
          @valueChange="(newHoursValue) => timeValueChangeHandler(row, newHoursValue)"
        >
        </FormattedNumberField>
      </v-col>
      <!--<v-col cols="12" class="pt-0 text-center">
        <v-btn
          color="primary"
          outlined
          block
        >
          <v-icon color="primary">article</v-icon>
        </v-btn>
      </v-col>-->
    </v-row>
  </div>
</template>

<script>
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    FormattedNumberField
  },
  props: [
    'day'
  ],
  computed: {
    showLabels () {
      return this.day.rows.length > 1
    }
  },
  methods: {
    timeValueChangeHandler (row, newHoursValue) {
      if (newHoursValue !== null && newHoursValue !== undefined) {
        this.$emit('entryTimeChange', row, newHoursValue)
      }
    }
  }
}
</script>

<style>
.time-sheet-entry-border {
  border: 0.1em solid #cccccc;
  border-radius: 7px;
  padding: 15px 10px;
}
</style>
